import React from 'react';
import NewServicesHeader from '../catalog/NewServicesHeader';
import ServicesSection from '../catalog/ServicesSection';

export default function LandingProductsSection({ searchParams }) {
  return (
    <section className="landing-products border-t border-hairline/25 bg-gradient-to-b from-transparent via-sky-wash/35 to-linen-canvas pt-10 md:pt-14 lg:pt-16">
      <NewServicesHeader compact />
      <ServicesSection searchParams={searchParams} variant="landing" />
    </section>
  );
}
